import * as React from 'react'
import * as ReactDOM from 'react-dom'
// import * as Raven from 'raven-js'

import Context from 'react-context-component'
import registerServiceWorker from 'common/client/registerServiceWorker'
import { store } from './client/store'
import history, {getLocationNoHashPath, getLocationPath} from 'common/history'
import universalRouter from 'common/universalRouter'
import * as queryString from 'query-string'
import { setServerRendered } from './ducks/serverRendered'
import logger from '../common/logger'
import { deepForceUpdate } from './utils/devUtils'
import { setScrollKept } from 'common/ducks/scroll/scrollKept'
import { setLocationKept } from 'common/ducks/locationKept'
import {
  DEFAULT_TITLE,
  DOCUMENT_HEAD_STYLE_ID,
  getVerticalByPath,
  getVerticalBySubVertical,
  isReactHome,
  Vertical,
} from './constants'
import { closePopupLayer } from 'common/ducks/popupLayer'
import { moveScrollByHistory, scrollToHashElement } from './utils/scrollUtils'
import { updateCustomMeta, updateLink } from './utils/DOMUtils'
import Error, { MessageTypes } from 'common/components/Error'
import { setScrollRestoredSelf } from 'common/ducks/scroll/scrollRestoredSelf'
import Loading from 'common/components/Loading'
import Nclicks from './components/Nclicks'
import { initialStateKey, getNextState } from './utils/flipState'
import { paramsDeserialize } from '@shopping/common'
import { initFlipState } from './ducks/flipState'
import { makeDefaultOgTag, setOgTagMeta } from 'common/utils/logic/ogTag'
import lcsLog from 'common/utils/lcs'
import hostConfig from 'common/config'
import projectConfig from 'common/config/project'
import { CommonCssId, commonSwCss } from 'common/utils/css/commonCss'
import { isMobileEnv } from './utils/common'
import { setGifAnimationFromStorage } from 'common/ducks/list/gifAnimation'

const Layout = require(`${process.env.PROJECT_NAME}/components/Common/Layout/Layout`).default

// try {
//   Raven.config(config.sentryReactDSN, {
//     captureUnhandledRejections: true,
//     autoBreadcrumbs: {
//       xhr: true, // XMLHttpRequest
//       console: true, // console logging
//       dom: true, // DOM interactions, i.e. clicks/typing
//       location: true, // url changes, including pushState/popState
//     },
//     ignoreErrors: [
//       /^{"jQuery/,
//       /^{"target/,
//       'naverapp_checkinstallapplication_response is not defined',
//       'naverapp_checknetworkstatus_response is not defined',
//     ],
//   }).install()
// } catch (e) {
//   console.error('client Entry Raven error', e)
// }

const rootEl = document.getElementById('root')
let currentLocation = history.location
let appInstance
let prevState = initialStateKey

const insertCss = (...styles) => {
  const removeCss = styles.map(x => x._insertCss())
  return () => {
    removeCss.forEach(f => f())
  }
}

const changeScrollPosition = (location, appInstance?: any) => {
  if (location && location.state && location.state.infinite) {
    return
  }

  moveScrollByHistory()
}

const onLocationChange = async (location, action?) => {
  // safari browser 의 경우, anchor tag 로 페이지 이동 후 history.back() 호출 시, 이후에 history.forward() 호출 시 'popState' event 발생. https://developer.mozilla.org/en-US/docs/Web/Events/popstate
  // 불필요한 route, component render 방지
  if (
    action === 'POP' &&
    getLocationPath(currentLocation) === getLocationPath(location) &&
    navigator.userAgent.toLowerCase().indexOf('safari') > -1
  ) {
    return
  }

  if (action === 'POP') {
    if (getLocationPath(currentLocation) === getLocationPath(location) && navigator.userAgent.toLowerCase().indexOf('safari') > -1) {
      return
    }
  }

  if (action === 'REPLACE' && store.getState().locationKept) {
    currentLocation = location
    store.dispatch(setLocationKept(false))
    return
  }
  if (action === 'REPLACE' && getLocationPath(currentLocation) === getLocationPath(location)) {
    return
  }

  if (
    currentLocation.pathname === location.pathname &&
    currentLocation.search === location.search &&
    currentLocation.hash !== location.hash
  ) {
    currentLocation = location
    return scrollToHashElement(location, 'hashChange')
  }

  const renderWithContext = (component, insertCss, store, curState) => (
    <Context {...{ insertCss, store, curState }}>
      <Nclicks>{component}</Nclicks>
    </Context>
  )
  currentLocation = location
  const isInitialRender = !action
  let curState
  if (isInitialRender) {
    // serverLocationPath 에는 hash 값이 포함되지 않음
    if (getLocationNoHashPath(location) !== store.getState().serverLocationPath
      && store.getState().serverRendered) {
        const regExp= /^[{}!+@#$%^&*"';:()?&=\-_ㄱ-ㅎ가-힣a-zA-Z0-9]+$/
        if (regExp.test(store.getState().serverLocationPath)) {
          return window.location.reload()
        } // IE9 한글 parameter, server <> client issue관련 예외처리.
    }
    curState = initialStateKey
    store.dispatch(setGifAnimationFromStorage())
  } else {
    if (store.getState().serverRendered) {
      store.dispatch(setServerRendered(false))
    }
    curState = getNextState(prevState) // clientEntry - curState 는 component 에서 StateProps connect 시 사용
    store.dispatch(initFlipState(curState))
    prevState = curState
  }

  store.dispatch(closePopupLayer())

  try {
    const metas = []
    const setMeta = (keyAttr, key, value) => metas.push({ keyAttr, key, value })

    if (!isInitialRender && action === 'POP' && !(window.history && 'scrollRestoration' in window.history)) {
      ReactDOM.render(
        renderWithContext(
          <Layout pathname={location.pathname}>
            <Loading isFull={true} />
          </Layout>,
          insertCss,
          store,
          curState,
        ),
        rootEl,
      )
    }

    const universalRouterContext = {
      store,
      action,
      curState,
      setMeta,
      pathname: location.pathname,
      queryParams: paramsDeserialize(queryString.parse(location.search)),
      headers: {
        cookie: document.cookie
      }
    }

    lcsLog(window, true)

    const routeResult = await universalRouter.resolve(universalRouterContext)
    store.getState().serverRendered && store.dispatch(setServerRendered(false))
    const { redirect, component, title = DEFAULT_TITLE } = routeResult
    // Prevent multiple page renders during the routing process
    if (currentLocation.key !== location.key) {
      return
    }

    if (redirect) {
      if (redirect.indexOf(hostConfig.windowUri[projectConfig.project]) > -1) {
        window.location.replace(redirect)
      } else {
        history.replace(redirect)
      }
      return
    }

    const renderReactApp = isInitialRender ? ReactDOM.hydrate : ReactDOM.render
    const isCurationProduct = universalRouterContext.pathname.indexOf('/ext/') > -1
    const isReactService = isReactHome(getVerticalByPath(universalRouterContext.pathname))
    appInstance = renderReactApp(renderWithContext(component, insertCss, store, curState), rootEl, () => {
      if (!isInitialRender && metas.length === 0) setOgTagMeta(setMeta, makeDefaultOgTag(getVerticalByPath(universalRouterContext.pathname)))
      setMetaTags(metas)
      if (isCurationProduct || isReactService) {
        let favicon
        if (isReactService) {
          const vertical = getVerticalByPath(universalRouterContext.pathname)
          favicon = `${process.env.PUBLIC_URL}favicon${vertical ? `_${vertical.toLowerCase()}` : ''}.ico`
        } else {
          const product = store.getState().product[curState]
          if (product.ssChannel) {
            favicon = `${process.env.PUBLIC_URL}favicon${
              getVerticalBySubVertical(product.ssChannel.windowSubVertical)
                ? `_${getVerticalBySubVertical(product.ssChannel.windowSubVertical).toLowerCase()}`
                : ''
              }.ico`
          }
        }
        updateLink(
          'shortcut icon',
          `${favicon}`,
        )
      }
      // not to make unnecessary CSSOM from second client-side rendering
      if (isInitialRender) {
        // Switch off the native scroll restoration behavior and handle it manually
        // https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
        // TODO - 최신 모바일사파리에 대한 예외 처리 필요 https://github.com/taion/scroll-behavior/issues/128 https://oss.navercorp.com/sau/layeredPage/issues/337
        if (window.history && 'scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'manual'
        }
        const styleElem = document.getElementById(DOCUMENT_HEAD_STYLE_ID)
        return styleElem && styleElem.parentNode.removeChild(styleElem)
      }

      if (isMobileEnv) {
        window.requestAnimationFrame(() => {
          const vertical = getVerticalByPath(universalRouterContext.pathname)
          const styleElem = document.getElementById(CommonCssId.COMMON_SW_CSS)
          if (!vertical || vertical === Vertical.GIFT) {
            if (styleElem) {
              styleElem.parentNode.removeChild(styleElem)
            }
          } else {
            if (!styleElem) {
              const style = document.createElement('style')
              style.id = CommonCssId.COMMON_SW_CSS
              style.type = 'text/css'
              style.innerText = commonSwCss
              document.head.appendChild(style)
            }
          }
        })
      }

      document.title = title
      if (store.getState().scrollKept) {
        return store.dispatch(setScrollKept(false))
      }

      if (store.getState().scrollRestoredSelf && action === 'POP') {
        return store.dispatch(setScrollRestoredSelf(false))
      }

      changeScrollPosition(location, appInstance)
    })
  } catch (error) {
    logger.error(error)
    document.title = '네이버쇼핑'
    // updateMeta('description', '네이버쇼핑') // 추후 og tag 등 필요한 meta tag 설정
    appInstance = ReactDOM.render(
      renderWithContext(
        <Layout pathname={location.pathname}>
          <Error message={MessageTypes.CONNECT_FAILURE} />
        </Layout>,
        insertCss,
        store,
        curState,
      ),
      rootEl,
    )
  }
}

history.listen(onLocationChange)
onLocationChange(currentLocation)
window.addEventListener('load', () => scrollToHashElement(history.location, 'load'))

registerServiceWorker()

// Enable Hot Module Replacement (HMR)
if ((module as any).hot) {
  (module as any).hot.accept('common/universalRouter', () => {
    if (appInstance && appInstance.updater.isMounted(appInstance)) {
      try {
        // Force-update the whole tree, including components that refuse to update
        deepForceUpdate(appInstance)
      } catch (error) {
        logger.error(error)
        ReactDOM.render(<>HMR 과정에 오류가 발생했습니다. f5를 눌러 페이지를 새로고침해주세요.</>, rootEl)
        return
      }
    }
    onLocationChange(currentLocation)
  })
}

const setMetaTags = (metas: any) => {
  metas.map(meta => updateCustomMeta(meta.keyAttr, meta.key, meta.value))
}
